export default {
  data: {
    inspectionQuotes: [],
    inspectionInvoices: [], 
    inspectionInvoice: {}, 
    inspectionFactory: {
      name: '',
      address: '',
      country: '',
      city: '',
      nameChi: '',
      addressChi: '',
      contactPerson: '',
      contactPersonEmail: '',
      contactPersonPhone: '',
      areaCode: '',
    },
    inspectionJobNoMap: {
      jobNoList: {
        jobNo: '',
      },
    },
    inspectionDocuments: [],
    inspectionImages: [],
    noPreference: 'yes',
    typeOfService: 'Final Random Inspection',
    currency: 'USD',
    reportGroupDetails: {},
    inspectionPOReportGroups: [
      {
        inspectionPOItems: [{}],
      },
    ],
    criticalLevel: 0,
    criticalMajorLevel: 2.5,
    criticalMinorLevel: 4.0,
    recordType: 'job',
    productCategoryId: 0,
    generalInspectLevel: 'na',
    factory: {},
    supplier: {},
    buyer: {},
    labList: {
      loading: false,
      data: [],
      error: null,
    },
  },
  status: 'uninitialized',
};
